import React, { PureComponent } from 'react';
import _ from "lodash";
import PropTypes from 'prop-types';

import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";

import {withStyles} from "@material-ui/core/styles";
import documentIcon from "../../images/document.svg";

const styles = () => ({
	documentIcon: {
		marginRight: 12,
		display: 'inline-block',
		width: 34,
		height: 40,
		backgroundImage: `url('${documentIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor : 'pointer',
	},
	note : {
		backgroundColor : '#D8F0FF',
		padding : 20,
		fontSize : 16,
		lineHeight: 1.4,
		marginBottom : 10,
		marginTop : 10,
		border: '1px solid #BADEFB',
	},
});

class ResourceListing extends PureComponent {

	render() {
		const { classes, path, resourceIds = [], resourceMap } = this.props;

		return (<>
			{resourceIds.map((resourceId, i) => {
				const resource = resourceMap[resourceId];
				if (!resource) {
					return (<div>Missing resource</div>);
				}

				const { contentType, url } = resource;

				let preview = (
					<div style={{width:75, height:75, backgroundColor:'#ddd'}}>
						<span style={{fontSize:14}}>No preview</span><br/>
						<a href={url} target="_blank" rel='noreferrer noopener'>Download</a>
					</div>
				);

				if (contentType) {
					if (contentType.match(/(png|jpg|jpeg|bmp)/)) {
						preview = (<img
							alt={`Attachment ${i + 1}`}
							style={{maxHeight: 175, maxWidth: 175}}
							src={url}
						/>);
					} else if (contentType.match(/(pdf)/)) {
						preview = (
							<object
								data={url}
								style={{maxHeight: 175, maxWidth: 122}}
								type="application/pdf"
								width="122"
								height="175"
							>
								<a href={url}>attachment.pdf</a>
							</object>
						);
					}
				}

				return (
					<Grid key={resourceId} container spacing={3} style={{marginTop : 10}}>
						<Grid item xs={12} md={12} style={{display : 'flex'}}>
							<div>{preview}</div>

							<div style={{display : 'flex', padding : 20}}>
								<a href={url} target="_blank" rel='noreferrer noopener'>
									<div className={classes.documentIcon} />
								</a>
								<div>
									<a href={url} target="_blank" rel='noreferrer noopener'>
										<div><strong>Contract Document #{i + 1}</strong></div>
										<div>{contentType}</div>
									</a>
								</div>
							</div>
							<div>
								<IconButton
									style={{transform:'translateY(50%)'}}
									color="primary"
									className={classes.button}
									onClick={() => this.props.removeInput(path, i)}
								>
									<DeleteIcon/>
								</IconButton>
							</div>
						</Grid>
					</Grid>
				);
			})}
		</>);
	}
}


ResourceListing.propTypes = {
	path : PropTypes.string.isRequired,
	resourceIds : PropTypes.array,
	resourceMap : PropTypes.object,
	removeInput : PropTypes.func.isRequired,
	classes : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
])(ResourceListing);